import React from 'react';
import styles from './Chronometer.module.css';
export default function ChronometerButton(_a) {
    var onClick = _a.onClick, isActive = _a.isActive;
    return (React.createElement("button", { type: 'button', title: '\u0425\u0440\u043E\u043D\u043E\u043C\u0435\u0440', className: isActive ? styles.chronButtonActive : styles.chronButton, onClick: function () {
            onClick();
        } }));
}
